var React;
export function requireReactLazily() {
    return React || (React = require('react'));
}
//# sourceMappingURL=react.js.map